import React, { Component } from 'react';
import MaskedInput from 'react-text-mask';

export default class ZipCodeField extends Component {
    render() {
        const { inputRef, ...other } = this.props;

        const commonZipCode = [/\d/, /\d/, /\d/, /\d/, /\d/];
        const extendedZipCode = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];

        return (
            <MaskedInput
                {...other}
                ref={ref => {
                    inputRef(ref ? ref.inputElement : null);
                }}
                guide
                mask={function (maskedValue, other, val) {
                    const rawValue = maskedValue.replace('-', '').match(/\d*/)[0];
                    if (rawValue.length > 5) {
                        return extendedZipCode;
                    }
                    return commonZipCode;
                }}
                placeholderChar={'_'}
                showMask
            />
        )
    }
}